module.exports = __webpack_public_path__ + "static/media/rating-star-icon.6131f7ee.svg";